import navHeaderStyles from './nav-header';

export default class NavHeader {
  constructor() {
    this.setDefaults();
    this.detectPrimaryFeatureQuoteCTA();
    this.attachClick();
    this.attachLevelTwoClick();
    this.attachLevelThreeClick();
    this.attachCloseButtonClick();
    this.closeSubMenus();
    this.btnSlideLeft();
    this.attachLevelOneHover();
  }

  setDefaults() {
    this.primaryFeatureGetQuote = document.querySelector('.primary-feature__quote-cta-link');
    this.hamburger = document.querySelector('.hamburger-icon');
    this.navHolder = document.querySelector('.nav-header-inner');
    this.getPriceButton = document.querySelector('.button-get-price-header');
    this.navOpen = false;
    this.subMenus = Array.prototype.slice.call(document.querySelectorAll('.sub-menu'),0);
    this.level3Menus = Array.prototype.slice.call(document.querySelectorAll('.level-3-menu'),0);
    this.mainContainer = document.getElementsByTagName('body')[0];
    this.getaQuoteLink = document.querySelector('a[href="/get-a-quote"]');
  }
  //start
  attachClick() {
    if(this.hamburger && this.navHolder){
      this.hamburger.removeEventListener("click", this.toggleNav.bind(this));
      this.hamburger.addEventListener("click", this.toggleNav.bind(this));
    }
    if(this.mainContainer) {
      this.mainContainer.addEventListener("click", this.closeSubMenus.bind(this));
    }    
  }

  attachLevelTwoClick() {
    this.closeSubMenus();
    var subMenus = this.subMenus;
    var openSubMenu = this.openSubMenu.bind(this);
    if (subMenus && subMenus.length > 0) {
      subMenus.forEach(function(subMenu) {
        var menuItem = subMenu.previousElementSibling;
        menuItem.addEventListener("click", openSubMenu);
        subMenu.parentElement.classList.add("has-sub-menu");
      });
    }
  }

  attachLevelThreeClick() {
    var level3Menus = this.level3Menus;
    var toggleLevel3Menu = this.toggleLevel3Menu;
    if (level3Menus && level3Menus.length > 0) {
      level3Menus.forEach(function(level3Menu) {
        var menuItem = level3Menu.previousElementSibling;
        menuItem.addEventListener("click", toggleLevel3Menu);
        level3Menu.parentElement.classList.add("has-sub-menu");
      });
    }
  }

  attachCloseButtonClick() {
    var closeThisSubMenu = this.closeThisSubMenu;
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.close-sub-menu button'),0);
    if (buttons && buttons.length > 0) {
      buttons.forEach(function(button) {
        button.addEventListener("click", closeThisSubMenu);
      })
    }
  }

  openSubMenu(e) {
    e.preventDefault();
    var listItem = e.target.parentElement;
    if (listItem && !listItem.classList.contains("sub-menu-open")) {
      this.closeSubMenus();
      listItem.classList.add("sub-menu-open");
      listItem.setAttribute('aria-expanded', 'true');
    } else {
      this.closeSubMenus();
    }
    e.stopPropagation();
  }

  toggleLevel3Menu(e) {
    e.preventDefault();
    var categoryHead = this.parentElement;
    var subMenu = categoryHead.querySelector('.level-3-menu');
    var show = function(elem) {
      var openLevel3Menus = Array.prototype.slice.call(document.querySelectorAll('.menu-item.sub-menu-open'), 0);
      openLevel3Menus.forEach(function(openMenu) {
        var level3Menu = openMenu.querySelector('.level-3-menu');
        level3Menu.style.height = level3Menu.scrollHeight + 'px';
        window.setTimeout(function() {
          level3Menu.style.height = '0'
        }, 1);
        window.setTimeout(function() {
          openMenu.classList.remove('sub-menu-open');
        }, 500);
        openMenu.parentElement.setAttribute('aria-expanded', 'false');
      })
      var getHeight = function() {
        elem.style.display = 'block';
        var height = elem.scrollHeight + 'px';
        elem.style.display = '';
        return height;
      };
      var height = getHeight();
      elem.parentElement.classList.add('sub-menu-open');
      elem.style.height = height;
      window.setTimeout(function () {
        elem.style.height = '';
      }, 500);
    };

    var hide = function (elem) {
      elem.style.height = elem.scrollHeight + 'px';
      window.setTimeout(function () {
        elem.style.height = '0';
      }, 1);
      window.setTimeout(function () {
        elem.parentElement.classList.remove('sub-menu-open');
      }, 500);
    };

    if (categoryHead) {
      if (categoryHead.classList.contains('sub-menu-open')) {
        hide(subMenu);
        categoryHead.setAttribute('aria-expanded', 'false');
      } else {
        var level3Menus = Array.prototype.slice.call(document.querySelectorAll('.level-3-menu'), 0);
        level3Menus.forEach(function(level3Menu) {
        });
        show(subMenu);
        categoryHead.setAttribute('aria-expanded', 'true');
      }
      e.stopPropagation();
    }
  }

  closeSubMenus() {
    var subMenus = Array.prototype.slice.call(document.querySelectorAll('.sub-menu'), 0);
    var level3Menus = Array.prototype.slice.call(document.querySelectorAll('.level-3-menu'), 0);
    subMenus.forEach(function(subMenu) {
      subMenu.parentElement.classList.remove("sub-menu-open");
      subMenu.parentElement.setAttribute('aria-expanded', 'false');
    });
    level3Menus.forEach(function(level3Menu) {
      level3Menu.parentElement.classList.remove("sub-menu-open");
      level3Menu.parentElement.setAttribute('aria-expanded', 'false');
    })
  }

  closeThisSubMenu(e) {
    if (this.parentElement) {
      var parentMenu = this.closest(".sub-menu-open");
      parentMenu.classList.remove("sub-menu-open");
      parentMenu.setAttribute('aria-expanded', 'false');
      e.stopPropagation();
    }
  }

  toggleNav() {
    this.navOpen = !this.navOpen;
    if(this.navOpen && this.navHolder){
      this.navHolder.classList.add("nav-open");
      this.navHolder.setAttribute('aria-expanded', 'true');
    } else if(this.navHolder) {
      this.navHolder.classList.remove("nav-open");
      this.navHolder.setAttribute('aria-expanded', 'false');
      this.closeSubMenus();
    }
  }

  detectPrimaryFeatureQuoteCTA() {
    if (!this.primaryFeatureGetQuote) {
      this.showGetPriceButton();
    } else {
      this.attachScrollDetection();
      this.checkCtaBoundaries();
    }
  }

  attachScrollDetection() {
    document.addEventListener("scroll", this.checkCtaBoundaries.bind(this));
  }

  checkCtaBoundaries() {
    let boundingBox = this.primaryFeatureGetQuote.getBoundingClientRect();
    if ( boundingBox.bottom > 88 ) {
      this.hideGetPriceButton();
    } else {
      this.showGetPriceButton();
    }
  }

  showGetPriceButton() {
    if(this.getPriceButton) {
      this.getPriceButton.classList.add('show-me');
    }
  }

  hideGetPriceButton() {
    if(this.getPriceButton) {
      this.getPriceButton.classList.remove('show-me');
    }
  }

  //"Get a quote" button slide from right to left on scroll
  btnSlideLeft(){
    if($(".primary-feature-component").length){
      $(window).scroll(function() {
        var heroHeightThreshold_end = $(".primary-feature-component").offset().top +$(".primary-feature-component").height() ;
        $(window).scroll(function() {
          var scroll = $(window).scrollTop();
          const navTel = $('.nav-flyout .nav-tel');
          const navCta = $('.nav-flyout .nav-cta');
          if (navCta && scroll >= heroHeightThreshold_end) {
            navCta.addClass('show-button');
            navTel.addClass('move-phone-number');
          } else {
            navCta.removeClass('show-button');
            navTel.removeClass('move-phone-number');
          }
        });
      });
    }
  }

  dropDownOnHover(){
    $(".nav-header-lower .nav-items .nav-item .nav-item__category").hover(function(){
      $(this).css("background-color", "green");
    }, function(){
      $(this).css("background-color", "pink");
    });
  }

  attachLevelOneHover(){
    $(".nav-header-lower nav .nav-items li.nav-item.has-sub-menu").hover(function() {
      var containerHeight = window.innerHeight - 80;
      if (this.scrollHeight > containerHeight) {
        this.querySelector('ul').classList.add('menu-two-columns');
      }
    }, function() {
      this.querySelector('ul').classList.remove('menu-two-columns');
    });
  };
}
